import React, { Component, Fragment } from 'react';
import { css } from 'aphrodite/no-important';
import { styles } from './AppliancesMostUsedStyles';
import ApplianceUsageDisc from '../components/ApplianceUsageDisc';

export default class AppliancesMostUsed extends Component {
  render() {
    const {most_used_appliances} = this.props

    return (
      <Fragment>
        <h3 className={css(styles.mostUsedTitle)}>Most Used this {this.props.period.time_unit}</h3>
        {!most_used_appliances.length ? <h3 className={css(styles.notUsed)}>No appliances used during this period</h3> : null}
        <div className={css(styles.mostUsedWrapper)}>
          {most_used_appliances && Object.keys(most_used_appliances).map((appliance, i) => {
            return (
                <ApplianceUsageDisc
                  title={most_used_appliances[appliance].name}
                  key={i}
                  order={i+1}
                  time={`${most_used_appliances[appliance].duration.value} ${most_used_appliances[appliance].duration.unit}`}
                  size={'small'}
                  id={most_used_appliances[appliance].appliance_type_id}
                  icon={most_used_appliances[appliance].icon}
                />
            )
          })}
        </div>
      </Fragment>
    );
  }
}
